import React from 'react'
import './header.css';
import Hero from '../../assets/hero.png'

const Header = () => {
  return (
    <div className='yellow__header section__padding' id='home'>
      <div className='yellow__header-content'>
        <h1 className='gradient__text'>
          Join the revolution as we digitize recycling. 
        </h1>
        <p>Our on-demand, data-driven recycling and waste management solutions address critical inefficiencies and environmental challenges faced by traditional systems. Leveraging real-time data, advanced technologies, and robust community engagement, we optimize waste collection, improve recycling rates, and promote sustainability.</p>
        <div className='yellow__header-content__input'>
          <input type='email' placeholder='Your Email'></input>
          <button type='button'>Get started</button>
          </div>
      </div>
        <div className='yellow__header-image'>
            <img src={Hero} alt='image'/>
        </div>
      
    </div>
  )
}

export default Header